import {FormikErrors} from 'formik';
import {taskValues} from './tasksFields';
import {
  TaskRegardingEntityEnum,
  TaskUrgencyEnum,
} from '../../../schema-types/globalTypes';

export const taskValidation: (values: taskValues) => FormikErrors<taskValues> = (
  values
) => {
  const errors: FormikErrors<taskValues> = {};
  // if (!values.contact) {
  //   errors.contact = 'Please select a contact';
  // }
  if (!values.subgroupId) {
    errors.subgroupId = 'Select a task';
  }
  if (!values.notes) {
    errors.notes = 'Please fill out the notes section';
  }
  if (!values.selectedEntityType) {
    errors.selectedEntityType = 'Select what this plan is for';
  }
  // now we have a selectedEntityType when "General Messages -> New review created" is selected
  // "selectedEntityType": "Handover notes completed and submitted.\n\nDialogue to be run to capture the correct project stage."
  // so we're changing the regarding check to acommodate it
  if (
    values.selectedEntityType &&
    (values.selectedEntityType === TaskRegardingEntityEnum.PLAN ||
      values.selectedEntityType === TaskRegardingEntityEnum.REQUIREMENT ||
      values.selectedEntityType === TaskRegardingEntityEnum.PLANNING_OBJECTIVE ||
      values.selectedEntityType === TaskRegardingEntityEnum.THIRD_PARTY)
  ) {
    if (!values.regarding) {
      errors.regarding = 'Required';
    }
    if (!values.selectedEntityTypeDetails) {
      errors.selectedEntityTypeDetails = 'Required';
    }
  }
  if (values.urgency === TaskUrgencyEnum.URGENT) {
    if (!values.urgencyReason) {
      errors.urgencyReason = 'Required';
    }
  }
  return errors;
};
